export default "__VITE_ASSET__BNILbwAu__"